export default __webpack_public_path__ + "static/media/Grace_Ní_Dhonnchú_AHV_In_Moms_We_Trust.f4d6bae2.jpg";